<template>
    <div class="h-screen-header overflow-y-auto" ref="genredetailview">

        <div class="tabs tabs-boxed mb-2 bg-base-100 !flex">
            <div class="flex justify-between w-full">
                <div>
                    <a v-for="{ value, text } in options" :key="value"
                       :class="{ 'tab': true, 'tab-active': section === value }">
                        <div @click="handleChangeTab(value)">
                            {{ text }}
                        </div>
                    </a>
                </div>
                <div>
                    <button class="btn btn-ghost btn-active btn-sm mr-1" @click="handleEdit(id)">
                        EDIT
                    </button>
                    <button class="btn btn-neutral btn-active btn-sm" onclick="genre_delete.showModal()">
                        DELETE
                    </button>
                </div>
            </div>
        </div>
        <div class="flex justify-between mb-1">
            <div class="text-2xl">: {{ id }}</div>
        </div>
        <template v-if="section === 'tracks'">
            <TrackList :tracks="tracks" :index-field="'index'" />
        </template>
        <template v-else>
            <AlbumList :items="albums" />
        </template>
        <div class="flex justify-center" v-if="loading">
            <span class="loading loading-infinity loading-lg"></span>
        </div>

        <div class="drawer drawer-end w-16 ml-2">
            <input id="edit-gr" type="checkbox" class="drawer-toggle" v-model="idEditGr" />
            <div class="drawer-content">
            </div>
            <div class="drawer-side">
                <label for="edit-gr" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 w-80 min-h-full bg-base-200 text-base-content">
                    <div class="font-medium text-xl mb-4">编辑流派/风格信息</div>

                    <div class="mb-1">风格名称:</div>
                    <div>
                        <input type="text"
                               v-model="id"
                               disabled
                               class="input input-bordered input-sm w-full max-w-xs" />
                    </div>
                    <div class="mb-1 mt-1">风格封面:</div>
                    <div style="width: 70%;display: flex;flex-direction: column;" v-if="reloadImg">
                        <!-- 图片上传 -->
                        <div class="relative">
                            <!-- 图片预览区域 -->
                            <div
                                class="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center hover:border-gray-400 transition-colors">
                                <div v-if="genreImagePreview" class="relative inline-block">
                                    <img :src="genreImagePreview" alt="风格封面"
                                        class="max-w-full max-h-48 rounded-lg shadow-md">
                                    <button @click.stop="removeGenreImage"
                                        class="absolute -top-2 -right-2 btn btn-circle btn-xs btn-error text-white hover:bg-red-600 z-50"
                                        type="button" style="pointer-events: auto;">
                                        ✕
                                    </button>
                                    <!-- 替换图片按钮 -->
                                    <button @click.stop="triggerGenreImageReplacement"
                                        class="absolute -bottom-2 -right-2 btn btn-circle btn-xs btn-neutral text-white z-50"
                                        type="button" style="pointer-events: auto;" title="替换图片">
                                        +
                                    </button>
                                </div>
                                <div v-else>
                                    <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor"
                                        fill="none" viewBox="0 0 48 48">
                                        <path
                                            d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                            stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <p class="mt-2 text-sm text-gray-500">点击上传或拖拽图片到此处</p>
                                    <p class="text-xs text-gray-400">支持 JPG, PNG, GIF (最大 5MB)</p>
                                </div>

                                <!-- 隐藏的文件输入 -->
                                <input ref="genreImageInput" type="file" accept="image/*"
                                    @change="handleGenreImageChange"
                                    class="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                                    :disabled="isUploadingGenreImage" v-show="!genreImagePreview">
                                <!-- 上传进度 -->
                                <div v-if="isUploadingGenreImage"
                                    class="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center rounded-lg">
                                    <div class="text-center">
                                        <span class="loading loading-spinner loading-md"></span>
                                        <p class="mt-2 text-sm text-gray-600">上传中...</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-neutral btn-sm btn-wide mt-2" @click="handleSave">保存</button>
                    <div class="mt-4">封面推荐:</div>
                    <div v-for="(item2, index) in albums" :key="index">
                        <div class="flex justify-center items-center mt-1 mb-2">
                            <img :src="item2.image"
                                 class="mask mask-squircle w-16 h-16 cursor-pointer object-contain"
                                 @click="handleCopy('genre_img', item2.image)">
                            <div class="flex-1 ml-2">
                                <div>{{item2.name}}</div>
                            </div>
                        </div>
                        <hr>
                    </div>
                </div>
            </div>
        </div>
        <dialog id="genre_delete" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold">删除风格</h3>
                <p class="py-4">从音乐收藏中删除此风格，但不会删除源文件。</p>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="handleDelete">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <button
            v-if="curScrollTop > 700"
            @click="scrollToTop"
            class="fixed bottom-8 right-8 bg-neutral-content hover:bg-accent hover: text-accent-content text-neutral font-bold py-2 px-4 rounded-full shadow-xl transition-colors duration-300"
        >
            <svg t="1730534469934" class="icon h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2399" width="200" height="200"><path d="M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3c-3.8 5.3-0.1 12.7 6.5 12.7h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" p-id="2400"></path></svg>
        </button>
    </div>
</template>
<script>
    import AlbumList from '@/views/library/album/AlbumList.vue'
    import TrackList from '@/views/library/track/TrackList.vue'

    export default {
        name: 'genre',
        components: {
            AlbumList,
            TrackList
        },
        props: {
        },
        data() {
            return {
                tracks: [],
                albums: [],
                id: this.$route.params.id,
                section: 'albums',
                loading: false,
                offset: 0,
                hasMore: true,
                loading2: false,
                offset2: 0,
                hasMore2: true,
                curScrollTop: 0,
                options: [
                    {text: '专辑', value: 'albums'},
                    {text: '歌曲', value: 'tracks'}
                ],
                FormData: {},
                idEditGr: false,
                uploadHeader: [
                    {name: 'X-CSRFToken', value: this.getCookie('django_vue_cli_csrftoken')},
                    {name: 'AUTHORIZATION', value: this.getCookie('AUTHORIZATION')}
                ],
                files1: [],
                uploadUrl: '/apimt/upload_image/',
                artistsData: [],
                // 新增的图片上传相关数据
                genreImagePreview: null,
                isUploadingGenreImage: false,
                reloadImg: true
            }
        },
        mounted() {
        },
        async created() {
            await this.loadMore()
        },
        activated() {
            // 事件监听
            this.$refs.genredetailview.addEventListener('scroll', this.listenBottomOut)
            window.genredetailview = this.$refs.genredetailview
            window.genredetailview.scrollTop = this.curScrollTop || 0
        },
        deactivated(){
            window.genredetailview.removeEventListener('scroll', this.listenBottomOut, false)

        },
        destroyed() {
        },
        methods: {
            async loadAlbums(offset) {
                this.albums = await this.$api.subsonic.getAlbumsByGenre(this.id, 50, offset)
            },
            async loadTracks(offset) {
                this.tracks = await this.$api.subsonic.getTracksByGenre(this.id, 50, offset)
            },
            handleChangeTab(value) {
                this.section = value
                this.loadMore()
            },
            handleEdit() {
                this.idEditGr = true
            },
            handleDelete() {
                this.$api.Task.deleteGenre({ 'id': this.id }).then((res) => {
                    if (res.result) {
                        this.$myMsg.notify({
                            title: '删除成功！',
                            type: 'success',
                            time: 2000,
                        })
                        this.$router.push({path: '/genres/a-z/'})
                    } else {
                        this.$myMsg.notify({
                            title: '删除失败！',
                            type: 'error',
                            time: 2000,
                        })
                    }
                })
            },
            loadMore() {
                if (this.section === 'tracks') {
                    this.loading2 = true
                    return this.$api.subsonic.getTracksByGenre(this.id, 50, this.offset2).then(tracks => {
                        this.tracks.push(...tracks)
                        this.offset2 += tracks.length
                        this.hasMore2 = tracks.length > 0
                        this.loading2 = false
                    })
                } else {
                    this.loading = true
                    return this.$api.subsonic.getAlbumsByGenre(this.id, 50, this.offset).then(albums => {
                        this.albums.push(...albums)
                        this.offset += albums.length
                        this.hasMore = albums.length > 0
                        this.loading = false
                    })
                }
            },
            listenBottomOut() {
                let hasMore
                let loading
                if (this.section === 'albums') {
                    hasMore = this.hasMore
                    loading = this.loading
                } else {
                    hasMore = this.hasMore2
                    loading = this.loading2
                }
                if (hasMore && !loading) {
                    const scrollTop = window.genredetailview.scrollTop || document.body.scrollTop
                    const scrollHeight = window.genredetailview.scrollHeight || document.body.scrollHeight
                    const clientHeight = window.genredetailview.clientHeight || document.body.clientHeight
                    this.curScrollTop = scrollTop
                    if (scrollTop + clientHeight >= scrollHeight - 50) {
                        this.loadMore()
                    }
                }
            },
            // 渲染图片
            handleRes(response) {
                if (response.result) {
                    this.FormData.genre_img = response.data
                    return true
                } else {
                    return false
                }
            },
            handleSave() {
                this.$api.Task.postGenre({
                    id: this.id,
                    genre_img: this.FormData.genre_img,
                }).then((res) => {
                    if (res.result) {
this.$myMsg.notify({
                            title: '修改成功！',
                            type: 'success',
                            time: 2000,
                        })                    } else {
                        this.$myMsg.notify({
                            title: '修改失败！',
                            type: 'error',
                            time: 2000,
                        })
                    }
                })
            },
            handleCopy(k, v) {
                if (k === 'genre_img') {
                    this.files1 = [
                        {
                            name: 'cover.png',
                            status: 'done',
                            url: v
                        }
                    ]
                    this.FormData.genre_img = v
                    // 同时设置新的图片预览
                    this.genreImagePreview = v
                } else {
                    this.FormData[k] += ',' + v
                }
            },
            scrollToTop() {
                window.genredetailview.scrollTop = 0
            },
            // 移除风格封面
            removeGenreImage() {
                this.genreImagePreview = null
                this.FormData.genre_img = ''
                if (this.$refs.genreImageInput) {
                    this.$refs.genreImageInput.value = ''
                }
            },
            // 触发风格封面替换
            triggerGenreImageReplacement() {
                // 直接创建临时input，更可靠
                this.createTempFileInput('genre')
            },
            
            // 创建临时文件输入
            createTempFileInput(type) {
                const input = document.createElement('input')
                input.type = 'file'
                input.accept = 'image/*'
                input.style.display = 'none'
                input.onchange = (event) => {
                    if (type === 'genre') {
                        this.handleGenreImageChange(event)
                    }
                    // 清理临时元素
                    if (input.parentNode) {
                        input.parentNode.removeChild(input)
                    }
                }
                document.body.appendChild(input)
                input.click()
            },
            // 处理风格封面图片选择
            handleGenreImageChange(event) {
                const file = event.target.files[0]
                if (!file) return
                
                // 验证文件类型
                if (!file.type.startsWith('image/')) {
                    this.$myMsg.notify({
                        title: '文件类型错误',
                        content: '请选择图片文件',
                        type: 'error',
                        time: 2000,
                    })
                    return
                }
                
                // 验证文件大小 (5MB)
                if (file.size > 5 * 1024 * 1024) {
                    this.$myMsg.notify({
                        title: '文件过大',
                        content: '图片大小不能超过5MB',
                        type: 'error',
                        time: 2000,
                    })
                    return
                }
                
                // 显示预览
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.genreImagePreview = e.target.result
                }
                reader.readAsDataURL(file)
                
                // 上传图片
                this.uploadImage(file, 'genre')
            },
            // 通用图片上传方法
            uploadImage(file, type) {
                const formData = new FormData()
                formData.append('upload_file', file)
                
                // 设置上传状态
                if (type === 'genre') {
                    this.isUploadingGenreImage = true
                }
                
                // 创建 XMLHttpRequest
                const xhr = new XMLHttpRequest()
                
                // 设置请求头
                xhr.open('POST', this.uploadUrl, true)
                xhr.setRequestHeader('X-CSRFToken', this.getCookie('django_vue_cli_csrftoken'))
                xhr.setRequestHeader('AUTHORIZATION', this.getCookie('AUTHORIZATION'))
                xhr.withCredentials = true
                
                // 处理响应
                xhr.onload = () => {
                    // 重置上传状态
                    if (type === 'genre') {
                        this.isUploadingGenreImage = false
                    }
                    
                    if (xhr.status === 200) {
                        try {
                            const response = JSON.parse(xhr.responseText)
                            if (this.handleRes(response)) {
                                this.$myMsg.notify({
                                    title: '上传成功',
                                    type: 'success',
                                    time: 2000,
                                })
                            } else {
                                this.$myMsg.notify({
                                    title: '上传失败',
                                    content: response.message || '未知错误',
                                    type: 'error',
                                    time: 2000,
                                })
                            }
                        } catch (e) {
                            console.log(e)
                            this.$myMsg.notify({
                                title: '上传失败',
                                content: '服务器响应格式错误',
                                type: 'error',
                                time: 2000,
                            })
                        }
                    } else {
                        this.$myMsg.notify({
                            title: '上传失败',
                            content: `HTTP错误: ${xhr.status}`,
                            type: 'error',
                            time: 2000,
                        })
                    }
                }
                
                // 处理错误
                xhr.onerror = () => {
                    if (type === 'genre') {
                        this.isUploadingGenreImage = false
                    }
                    this.$myMsg.notify({
                        title: '上传失败',
                        content: '网络错误',
                        type: 'error',
                        time: 2000,
                    })
                }
                
                // 发送请求
                xhr.send(formData)
            }
        }
    }
</script>
